import React from "react";

import AgroTradeHeader from "../components/Header";
import LandingFooter from "../../landing/components/Footer";

function WholesalePage() {
    return (
        <div className="def_background min-h-screen flex flex-col">
            <AgroTradeHeader />
            <main className="flex-1">
                <div className="max-w-[1200px] mx-auto w-full px-4 py-10 lg:px-0">
                    <h1 className="text-2xl font-semibold mb-4">Оптовые продажи</h1>
                    <p className="text-sm text-[#4b5563]">
                        Здесь будет статическая страница с информацией об оптовых продажах
                        агропродукции через платформу AgroTrade.
                    </p>
                </div>
            </main>
            <LandingFooter />
        </div>
    );
}

export default WholesalePage;

